import { DateTime } from 'luxon';
import moment from 'moment';

export const parseDatetimeString = (dateString :string) :string => {
  return DateTime.fromISO(dateString, {
    zone: 'utc',
  }).toISODate();
};

export const parseDatetimeStringToISOString = (
  dateString :string,
  sourceTime ?:Date,
) :string => {
  return DateTime.fromISO(dateString, {
    zone: 'utc',
  }).toISO();
};

export const parseUTCStringToDateISO = (
  dateString :string,
  options ?:{
    allowNull ?:boolean;
    zone ?:string;
  },
) :string => {
  options = {
    // DEFAULTS
    allowNull: false,
    zone: 'local',

    ...options,
  };

  const INVALID = 'Invalid date';

  if (dateString == null) {
    return options.allowNull ? null : INVALID;
  }

  // Parse the date as UTC and then convert to the specified timezone
  const dt = DateTime.fromISO(dateString, { zone: 'utc' }).setZone(options.zone);

  return dt.isValid ? dt.toISODate() : INVALID;
};

export const formatDateToISOString = (inputDate :any) :string => {
  let valueDateString :string = inputDate;
  if (hasTime(inputDate) && typeof inputDate === 'string') {
    const date = new Date(inputDate);

    return date.toISOString();
  }
  if (moment.isMoment(inputDate)) {
    valueDateString = inputDate.format('YYYY-MM-DD');
  }
  const currentDate = new Date();
  const formatDate = new Date(
    `${valueDateString} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`,
  );

  return formatDate.toISOString();
};

export const hasTime = (dateString :any) :boolean => {
  // Regular expression to check for time format in the string
  const timeRegex = /([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?( [APap][Mm])?/;

  return timeRegex.test(dateString);
};

export function relativeTime(value :string) :{ value :number; unit :string } {
  const now = new Date();
  const date = new Date(value);
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return { value: diffInSeconds, unit: 'second' };
  } else if (diffInSeconds < 3600) {
    return { value: Math.floor(diffInSeconds / 60), unit: 'minute' };
  } else if (diffInSeconds < 86400) {
    return { value: Math.floor(diffInSeconds / 3600), unit: 'hour' };
  } else if (diffInSeconds < 604800) {
    return { value: Math.floor(diffInSeconds / 86400), unit: 'day' };
  } else if (diffInSeconds < 2592000) {
    return { value: Math.floor(diffInSeconds / 604800), unit: 'week' };
  } else if (diffInSeconds < 31536000) {
    return { value: Math.floor(diffInSeconds / 2592000), unit: 'month' };
  } else {
    return { value: Math.floor(diffInSeconds / 31536000), unit: 'year' };
  }
}

export const formatFilterFromDateToISOString = (inputDate :any) :string => {
  let valueDateString :string = inputDate;
  if (hasTime(inputDate) && typeof inputDate === 'string') {
    const date = new Date(inputDate);

    return date.toISOString();
  }
  if (moment.isMoment(inputDate)) {
    valueDateString = inputDate.format('YYYY-MM-DD');
  }
  const formatDate = new Date(`${valueDateString} ${0}:${0}:${0}`);
  if (isNaN(formatDate.getTime())) {
    return '';
  }

  return formatDate.toISOString();
};

export const formatFilterToDateToISOString = (inputDate :any) :string => {
  let valueDateString :string = inputDate;
  if (hasTime(inputDate) && typeof inputDate === 'string') {
    const date = new Date(inputDate);

    return date.toISOString();
  }
  if (moment.isMoment(inputDate)) {
    valueDateString = inputDate.format('YYYY-MM-DD');
  }
  const formatDate = new Date(`${valueDateString} ${23}:${59}:${59}`);
  if (isNaN(formatDate.getTime())) {
    return '';
  }

  return formatDate.toISOString();
};
